var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hero-container",style:({backgroundImage:'url(' + _vm.imageUrl + ')'})},[_c('div',{staticClass:"img-container"},[_c('h1',{staticClass:"text"},[_c('span',{staticStyle:{"font-weight":"300"}},[_vm._t("normal")],2),_c('br'),_c('span',{class:{bold: _vm.shouldBeBold}},[_vm._t("bold")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }